var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"color-white step bg-color-secondary color-white font-xs",class:[
    {'step--current' : _vm.isActive},
    {'step--disabled': !_vm.isActive && !_vm.isClickable}
  ],attrs:{"to":_vm.to},on:{"click":_vm.go}},[_c('span',{staticClass:"bubble text-center"},[_vm._t("default",[_vm._v("\n      "+_vm._s(_vm.number)+"\n    ")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }